import Bucket from "./components/Bucket";

function App() {
  return (
    <div className="App">
      <Bucket/>
    </div>
  );
}

export default App;
